var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMicrosoftIcon = function SvgMicrosoftIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H16V16H0Z",
    fill: "#f3f3f3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1,1H7.936V7.936H1Z",
    transform: "translate(-0.306 -0.306)",
    fill: "#f35325"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12,1h6.936V7.936H12Z",
    transform: "translate(-3.63 -0.306)",
    fill: "#81bc06"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1,12H7.936v6.936H1Z",
    transform: "translate(-0.306 -3.63)",
    fill: "#05a6f0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12,12h6.936v6.936H12Z",
    transform: "translate(-3.63 -3.63)",
    fill: "#ffba08"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMicrosoftIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/microsoftIcon.b8948848.svg";
export { ForwardRef as ReactComponent };